export function hasMeaningfulLeadDescription(
  html?: string | null,
): boolean {
  if (!html) return false;

  const visibleText = html
    .replace(/<br\s*\/?>/gi, '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;|&#x0*a0;/gi, ' ')
    .replace(/\u00a0/g, ' ')
    .trim();

  return visibleText.length > 0;
}

export function shouldDeferLeadFieldCloseToBlur(
  activeElement: Element | null,
  fieldPath: string,
): boolean {
  const activeInputWillBlur = !!activeElement?.matches(
    `input[data-field="${fieldPath}"], textarea[data-field="${fieldPath}"]`,
  );
  const activeDescriptionEditorWillBlur =
    fieldPath === 'description' &&
    !!activeElement?.matches('.ql-editor');

  return activeInputWillBlur || activeDescriptionEditorWillBlur;
}
